

export const data = [
  {
    project: "Project 1:",
    title: "Meta & Google Ads",
    duration: "15 Hours(& 15 Days of Live Campaign)",
    desc:
      "Here, you’ll be creating and executing an ad campaign for the brand Unleavables* which will include:",
    disclaimer: "*Brands change every batch",
    color: "#58BDF0",
    hColor: "#58BDF0",
    bg: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm42p0tm5.png",
    icon: 'https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t7gih5.png',
    mobImg: 'https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t68g8h.png',
    highlight: "Presentations and Mock Interviews",
    points: [
      "Projects Briefing",
      "Meeting with the industry experts",
      "Making the campaigns live with the given budget",
      "Media Strategy Submission & Campaign Optimization",
      "Campaign Ends and Final Reports are Created",
    ],
    subdescription: [
      "Understanding the brand and business objectives",
      "Understanding the target audience",
      `Creating media plan, ad copies, bidding strategies, placement strategies and<br/> delivery methods`,
      `Taking the campaign live on Meta and<br/> Google for a given duration and optimizing it regularly to meet the targets.`,
    ],
    AddIamge: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46l48zc.png",
    AddIamgeMob: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46l48zc.png",
    bgTopRight: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm42prp98.png",
  },
  {
    project: "Project 2:",
    title: "Amazon Ads",
    duration: "18 Hours (& 7 Days of Live Campaign)",
    desc: `Here, you will be running live campaigns on Amazon to sell the given SKUs for Seasoned Snack*. This live E-commerce project will involve:`,
    disclaimer: "*Brands change every batch",
    color: "#D86136",
    hColor: "#E38C54",
    bg: 'https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t76o25.png',
    icon: 'https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t7d8sb.png',
    mobImg: 'https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t6vd1g.png',
    highlight: "Presentations and Mock Interviews",
    points: [
      "Project Briefing",
      "Meeting with the industry experts",
      "Making the campaigns live with the given budget",
      "Media Strategy Submission & Campaign Optimization",
      "Campaign Ends and Final Reports are Created",
    ],
    subdescription: [
      `Creating a strategy based on business and<br/> user understanding`,
      `Creating a media plan with the targeting,<br/> bids, budgets and bidding strategies using<br/> past data.`,
      `Taking the campaign live on Amazon for a<br/> given duration and optimizing it regularly to meet the targets.`,
    ],
    AddIamge: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46l6llp.png",
    AddIamgeMob: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46l6llp.png",
    bgTopRight: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm42prp98.png",
  },
  {
    project: "Project 3:",
    title: "Search Engine Optimization",
    duration: "11.5 Hours",
    desc:
      "You’ll be creating an end-to-end SEO strategy for Unleavables*. This will involve:",
    disclaimer: "*Brands change every batch",
    color: "#f1ae13",
    hColor: "#f1ae13",
    bg: 'https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t6yteu.png',
    icon: 'https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t7238h.png',
    mobImg: 'https://s3.ap-south-1.amazonaws.com/convexstorage.kraftshala.com/production/453b391a-01f1-4431-a281-8c58470d35bc/events/banner-upload/14i86y3bdzm2t6qwtv.png',
    highlight: " Presentation",
    points: [
      "Project Briefing",
      "Catchup with the experts",
      "SEO and Content Strategy Submission",
      "Blog Publishing Using Wordpress",
    ],
    subdescription: [
      `Conducting on-page audits, technical<br/> audits and backlink audits of the website`,
      "Finding methods to fix the issues identified.",
      "Creating content strategy",
      "Writing SEO optimized blog using ChatGPT",
      "Publishing the blog using Wordpress.",
    ],
    AddIamge: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46l8oll.png",
    AddIamgeMob: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm46layeq.png",
    bgTopRight: "https://s3.ap-south-1.amazonaws.com/testconvexstorage.kraftshala.com/test/18d4a409-0f1b-479b-bad9-c100958b83c1/events/banner-upload/14i86y70rnm42prp98.png",
  },
];
